// tooltip消息提示文案map
export const tooltipstopReasonTypeMap = {
	0: ' ',
	1: '插件退出登录',
	2: '官方达人广场页面关闭',
	3: '手动关闭任务',
	4: '筛选条件关闭',
};
